import { TextInput, TextInputProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormTextFieldProps<Values = Record<string, unknown>>
  extends TextInputProps,
    IFocusableFormField<Values> {}

export const FormTextField: <Values = Record<string, unknown>>(
  props: IFormTextFieldProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  return (
    <TextInput
      {...parentForm.getInputProps(fieldName)}
      {...rest}
      ref={elementRef}
    />
  );
};
